import React, {FC, ReactNode} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import MenuLabel from "./styled/MenuLabel"

interface Context {
  appPath: string
}

interface Props {
  app?: string
  color?: string
  to: string
  inSubMenu?: boolean // temporary workaround until proper comps in place
  subLink?: boolean
  hightlightLink?: boolean
  children: ReactNode
}

const MenuLink: FC<Props> = (props, {appPath}: Context) => {
  const linkProps: Props & {isCurrent?: boolean} = {...props}

  linkProps.isCurrent = window.location.pathname === `${appPath}${props.to}`

  return <MenuLabel {...linkProps} />
}

MenuLink.contextTypes = {
  appPath: PropTypes.string.isRequired
}

export default styled(MenuLink)<Props>`
  font-size: 10px;
  margin: 0;
  font-weight: bold;
  color: ${({color, theme}) => color || theme.colors.greys.mediumDark};
  padding: ${({theme}) => theme.spacing.two};
`
